// extracted by mini-css-extract-plugin
export var icon = "_wx-0";